module.exports = __webpack_public_path__ + "img/vanilla.79edd62c.png";